import { render, staticRenderFns } from "./Integral.vue?vue&type=template&id=3f4b6d6a&scoped=true&"
var script = {}
import style0 from "./Integral.vue?vue&type=style&index=0&id=3f4b6d6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4b6d6a",
  null
  
)

export default component.exports